import { getMinutesAndSeconds } from '@hotjar/insights-common/lib/getMinutesAndSeconds';
import { Cell } from './RecordingOverviewWidgetCell';

import type { RecordingOverviewWidgetCellParams } from './RecordingOverviewWidgetCell';

export const RecordingOverviewWidgetCellDuration = ({
  recording,
}: RecordingOverviewWidgetCellParams): JSX.Element | null => {
  if (!recording) return null;

  return <Cell>{`${getMinutesAndSeconds(recording.duration)} min`}</Cell>;
};
